import { inject } from '@angular/core';
import { AuthService } from '../Services/auth.service';

export const authGuard = async () => {
  const authService = inject(AuthService);  
  const autenticado = authService.isAuthenticated;

  if (!autenticado) {
    return authService.logoutStorage(); 
  }

  const resp = await authService.checkAccessMenu();

  if (!resp) {
    return authService.goUnauthorized(true);
  }

  return true;
};
